import CommunityUpdateManage from "./community-update-manage";

export default CommunityUpdateManage